module.exports = __webpack_public_path__ + "static/img/case1.f00ddd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case1.png
// module id = kr4m
// module chunks = 3